import { PAGE_MAX_WIDTH } from "./components/Page";
import theme from "./theme";

// Parse out the value of the margin that is applied to the image, and add that to the page max width constant
// Assumes root element (<html>) font size of 16px
export const OVERSPILL_MEDIA_QUERY =
  Number.parseFloat(theme.space[6].replace("rem", "")) * 2 * 16 +
  PAGE_MAX_WIDTH;
